<reset-password-translations></reset-password-translations>
<div class="row">
  <div class="col-7 col-sm-12">
    <div class="login-block">
      <h1 i18n="forgot password title@@forgot.password.title">Forgot password</h1>

      <p i18n="forgot password description@@forgot.password.description">
				Fill in your e-mail address below,
				and we will e-mail you with the instructions to create a new password.
			</p>

      <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit(forgotPasswordForm.value)">
        <div class="form-row">
          <label class="form-label" for="email"
            i18n="Forgot password form: e-mail label@@forgot.password.form.email">
						E-mail
					</label>

          <div class="form-input-container">
            <input [formControl]="forgotPasswordForm.controls['email']"
              autocomplete="off"
              id="email"
              name="email"
              required
              title="Please enter your E-mail"
              type="email" />

            @if (!forgotPasswordForm.controls['email'].valid) {
              @if (forgotPasswordForm.controls['email'].hasError('required')
                && forgotPasswordForm.controls['email'].touched) {
                <p
                  class="form-input-error"
                  i18n="Error: enter e-mail@@forgot.password.error.email.empty">
								Please enter an e-mail address
							</p>
              }
              @if (forgotPasswordForm.controls['email'].hasError('incorrectMailFormat')
                && forgotPasswordForm.controls['email'].touched
                && !forgotPasswordForm.controls['email'].hasError('required')) {
                <p
                  class="form-input-error"
                  i18n="Error: enter valid e-mail@@forgot.password.error.email">
								Please enter a valid e-mail address
							</p>
              }
            }
          </div>
        </div>

        @if (formError) {
          <div class="form-row">
            <div class="form-input-container">
              <p class="form-input-error"
                i18n="Forgot password form: no account found@@forgot.password.form.no.account">
							We do not have an account with this e-mail address.
							Please check if this e-mail address is correct, or contact us: +31 (0)174 - 671 414
						</p>
            </div>
          </div>
        }

        <div class="button-bar button-bar--password">
          <button [disabled]="!forgotPasswordForm.valid"
            class="button theme-btn-secondary"
            type="submit"
            i18n="Send e-mail@@forgot.password.form.button">
						Send e-mail
					</button>

          <div class="form-back-to-login">
            <a href="/login" i18n="back to login@@forgot.password.back.to.login">
							Back to login
						</a>
          </div>
        </div>
      </form>
    </div>
  </div>

  @if (isShowRegisterBlock()) {
    <div class="col-5 col-sm-12">
      <div class="login-block login-block--register">
        <h2 i18n="Login page: become a customer@@login.page.become.customer">
				Become a customer of Noviflora?
			</h2>
        <p i18n="Login page: register and receive info@@login.page.register.text">
				Register and receive login information
			</p>
        <div class="button-bar">
          <a class="button button--secondary theme-btn-secondary-outline"
            href="{{applicationService.getRegisterUrl()}}"
          i18n="register link@@login.page.register.link">Register</a>
        </div>
      </div>
    </div>
  }
</div>
